import { render, staticRenderFns } from "./DataScreen.vue?vue&type=template&id=4b48bc17&scoped=true"
import script from "./DataScreen.vue?vue&type=script&lang=js"
export * from "./DataScreen.vue?vue&type=script&lang=js"
import style0 from "./DataScreen.vue?vue&type=style&index=0&id=4b48bc17&prod&lang=scss&scoped=true"
import style1 from "./DataScreen.vue?vue&type=style&index=1&id=4b48bc17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48bc17",
  null
  
)

export default component.exports